<template>
  <section class="profile-progress">
    <h3 class="profile-progress__title">
      Profile progress:
      <span class="font-weight-bold ml-3">{{ progress.label }}</span>
    </h3>

    <div class="profile-progress__bar">
      <div
        v-for="index in 3"
        :key="index"
        class="profile-progress__bar-step"
        :class="{ 'profile-progress__bar-step--completed': index <= progress.level }"
      ></div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    progress: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isProfileUncompleted() {
      return this.level < 3;
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-progress {
  margin-bottom: 12px;
  padding: 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__title {
    color: $color--primary;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__bar {
    display: flex;
    margin-bottom: 8px;
  }

  &__bar-step {
    height: 18px;
    background: #E2E6EA;
    margin: 0 2px;
    flex-grow: 1;

    &:first-child {
      margin-left: 0;
      border-radius: 8px 0 0 8px;
    }
    &:last-child {
      margin-right: 0;
      border-radius: 0 8px 8px 0;
    }
    &--completed {
      background: $color--blue;
    }
  }

  &__complete {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
